import Tooltip from '@mui/material/Tooltip';
import {
    POST_CHANNEL,
    POST_STATUS,
    POST_STATUS_LABEL_KEY,
    POST_STATUS_TONE,
    normalizePlatform,
} from '@constants/social-posts';
import { translateApiError } from '@helpers/api';
import StatusBadge from './StatusBadge';

export const tooltipFor = ({ status, t, failReason, failReasonCode, platform }) => {
    if (status === POST_STATUS.FAILED) {
        return translateApiError(failReasonCode, failReason || '');
    }
    if (status === POST_STATUS.PUBLISHING && normalizePlatform(platform) === POST_CHANNEL.TIKTOK) {
        return t('SocialPosts.tiktok.publishingTooltip');
    }
    return '';
};

const PostStatusChip = ({ status, t, failReason, failReasonCode, platform }) => {
    const badge = (
        <StatusBadge status={status} toneByStatus={POST_STATUS_TONE} labelKeyByStatus={POST_STATUS_LABEL_KEY} t={t} />
    );

    const title = tooltipFor({ status, t, failReason, failReasonCode, platform });
    if (!title) return badge;
    return (
        <Tooltip title={title} arrow>
            {/* flex, not inline-flex: an inline box sits on the cell's text baseline and
                renders a few px lower than the chips of untooltipped rows */}
            <span style={{ display: 'flex' }}>{badge}</span>
        </Tooltip>
    );
};

export default PostStatusChip;
